import { MetricPanel } from "./AnalyticsVisuals";
import { BuildOutlined } from "@mui/icons-material";

import { MaintenanceAnalytics as MaintenanceAnalyticsType } from "../types";

interface MaintenanceAnalyticsProps {
  data?: MaintenanceAnalyticsType | null;
}

const MaintenanceAnalytics = ({ data }: MaintenanceAnalyticsProps) => {
  const rows = [
    ["Tickets", data?.tickets ?? 0],
    ["Open Tickets", data?.openTickets ?? 0],
    ["Completed", data?.completedTickets ?? 0],
    ["Assignments", data?.assignments ?? 0],
    ["Invoices", data?.invoices?.total ?? 0],
    ["PM Due", data?.preventiveSchedule?.due ?? 0],
  ];

  return <MetricPanel title="Maintenance Analytics" rows={rows} icon={<BuildOutlined />} />;
};

export default MaintenanceAnalytics;
